/* Copyright (c) 2023-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { FlexContainer, theme } from "@nordcloud/gnui";

export const ChildrenWrap = styled.div`
  flex: 1;
  align-self: center;
`;

export const StatusBarWrap = styled(FlexContainer)`
  width: 100%;
  height: ${theme.lineHeight};
  border-radius: 0.25rem;
  overflow: hidden;
`;

type StatusBarItemProps = {
  width: string;
  background: string;
};

export const StatusBarItem = styled.div<StatusBarItemProps>`
  height: 100%;
  width: ${({ width }) => width};
  background: ${({ background }) => background};
`;

export const LegendItemWrap = styled.div`
  margin-right: ${theme.spacing.spacing07};
`;

type ValueTagProps = {
  color: string;
};

export const ValueTag = styled.span<ValueTagProps>`
  display: inline-block;
  width: 2rem;
  margin-right: ${theme.spacing.spacing03};
  font-size: ${theme.fontSizes.sm};
  color: ${theme.color.text.text04};
  background-color: ${({ color }) => color};
  text-align: center;
  line-height: 1.75;
  border-radius: ${theme.radius.sm};
`;

export const DoughnutChartTextWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;
